import {MinusCircleOutlined, PlusOutlined} from '@ant-design/icons';
import {Button, Form, InputNumber, Select} from 'antd';
import {walletCurrencies} from 'utils/mock';
import styles from '../../subscriptionSettings.module.scss';
import CatalogModalSection from '../catalogItemModal/CatalogModalSection';

const currencyOptions = walletCurrencies.map(currency => ({
  value: currency.key,
  label: `${currency.name} (${currency.key})`,
}));

const BundlePricesSection = () => {
  return (
    <CatalogModalSection
      title="Bundle prices"
      description="Add prices for bundle. Same prices shared across selected bundle rows.">
      <Form.List
        name="bundlePrices"
        rules={[
          {
            validator: async (_, rows) => {
              if (!rows?.length) {
                throw new Error('Add at least one price');
              }

              const seen = {};
              rows.forEach(row => {
                const currency = row?.currency;
                const amount =
                  row?.amount === undefined || row?.amount === null
                    ? null
                    : Number(row.amount);
                if (!currency || amount === null || Number.isNaN(amount)) {
                  return;
                }
                const key = `${currency}-${amount}`;
                if (seen[key]) {
                  throw new Error(
                    'Duplicate price rows not allowed. Keep currency + amount unique.',
                  );
                }
                seen[key] = true;
              });
            },
          },
        ]}>
        {(fields, {add, remove}, {errors}) => (
          <div className={styles['catalog-price-list']}>
            <div className={styles['catalog-price-list-header']}>
              <span>Price rows</span>
              <Button
                type="dashed"
                icon={<PlusOutlined />}
                onClick={() => add({currency: undefined, amount: undefined})}>
                Add price row
              </Button>
            </div>

            {fields.map(field => (
              <div key={field.key} className={styles['catalog-price-row']}>
                <div className={styles['bundle-price-row-grid']}>
                  <Form.Item
                    label="Currency"
                    name={[field.name, 'currency']}
                    rules={[{required: true, message: 'Currency required'}]}>
                    <Select
                      showSearch
                      optionFilterProp="label"
                      options={currencyOptions}
                      placeholder="Select currency"
                    />
                  </Form.Item>

                  <Form.Item
                    label="Amount"
                    name={[field.name, 'amount']}
                    rules={[
                      {required: true, message: 'Amount required'},
                      {
                        validator: async (_, value) => {
                          if (value === undefined || value === null) {
                            return;
                          }
                          if (Number(value) <= 0) {
                            throw new Error('Amount must be greater than 0');
                          }
                        },
                      },
                    ]}>
                    <InputNumber
                      min={0}
                      step={0.01}
                      precision={2}
                      style={{width: '100%'}}
                      placeholder="Enter amount"
                    />
                  </Form.Item>

                  <Form.Item
                    label=" "
                    className={styles['bundle-remove-field']}>
                    <Button
                      type="text"
                      danger
                      icon={<MinusCircleOutlined />}
                      disabled={fields.length <= 1}
                      onClick={() => remove(field.name)}
                    />
                  </Form.Item>
                </div>
              </div>
            ))}
            <Form.ErrorList errors={errors} />
          </div>
        )}
      </Form.List>
    </CatalogModalSection>
  );
};

export default BundlePricesSection;
